export default __webpack_public_path__ + "static/media/Tomato.31a357a6.png";